export const formataValorNumerico = (valor: string): number => {
  valor = valor.replace(',', '.');
  valor = valor.replace(/\.(?=\d{3,})/g, '');

  return parseFloat(valor);
};
